<template>
  <div class="solfigrf-ranges solfigrplayers">
    <GwTitleTooltip
      class="solfigrplayers_title"
      :title="$t('solfigr.ranges.title')"
      :tooltip="$t('solfigr.ranges.title_tooltip')"
    />
    <div class="solfigrplayers_content">
      <SolfigrPlayer
        v-for="player in playersWithId"
        :key="player.id"
        :loading="loading"
        :item="player"
        :canRemove="players.length > 2"
        class="gw_btn_hover_back"
        style="--ra-table-size: var(--player-table-size)"
        :data-tst="`player${player.position}`"
        :hasEditableName="$store.getters.user_has_flag('SOL_3WAY')"
        @click="$emit('click', player.position)"
        @remove:player="$emit('click:remove', player)"
        @update:player="val => updatePlayer(val, player.id)"
      />
      <SolfigrAddPlayer
        v-if="shouldShowAddPlayerButton"
        @click="$emit('click:add')"
      />
      <SolfigrComingSoonPlayer v-if="showComingSoonPlayerIcm" />
    </div>
  </div>
</template>

<script>
import GwTitleTooltip from '@/components/Dialogs/UserSettingsDialog/GwTitleTooltip'
import SolfigrPlayer from '@/components/ConfigureSolution/SolfigrPlayer'
import SolfigrAddPlayer from '@/components/ConfigureSolution/SolfigrAddPlayer'
import SolfigrComingSoonPlayer from '@/components/ConfigureSolution/SolfigrComingSoonPlayer'
import float_mix from '@/mixins/float_mix'
import { SNK } from '@/helpers/helpers'

export default {
  name: 'SolfigrPlayers',
  components: {
    SolfigrPlayer,
    GwTitleTooltip,
    SolfigrAddPlayer,
    SolfigrComingSoonPlayer,
  },
  mixins: [float_mix],
  props: {
    gameformat: Object,
    readOnly: Boolean,
    instaApply: Boolean,
    shortcut: Object,
    loading: Boolean,
    blurred: Boolean,
    players: Array,
    shouldShowAddPlayerButton: Boolean,
    showComingSoonPlayerIcm: { default: false, type: Boolean },
    namespace: String,
  },
  emits: ['click', 'click:add', 'click:remove'],
  methods: {
    updatePlayer(val, playerId) {
      const updatedPlayers = JSON.parse(JSON.stringify(this.playersWithId))
      const playerIndex = updatedPlayers.findIndex(p => p.id === playerId)
      updatedPlayers[playerIndex] = {
        ...updatedPlayers[playerIndex],
        ...val,
      }

      const updatedPlayer = updatedPlayers[playerIndex]
      updatedPlayers.forEach((p, i) => {
        if (i !== playerIndex && p.display_position === updatedPlayer.display_position) {
          updatedPlayers[i] = {
            ...p,
            display_position: p.display_position,
          }
        }
      })

      const players_to_update = updatedPlayers.map(({ id, ...player }) => player) // remove id from updated player objects
      this.$store.dispatch(SNK('slfrm_updatePlayers', this.namespace), players_to_update)
    },
  },
  computed: {
    playersWithId() {
      return this.players.map(p => ({
        ...p,
        id: `player_${p.position.replace('+', '').toLowerCase()}`,
      }))
    },
  },
}
</script>

<style lang="scss" scoped>
.solfigrplayers {
  min-height: 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  --player-table-size: 4.125rem;
  &_title {
    margin: 0 0 0.325rem 0;
  }
  &_content {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
  }
}
</style>
